module.exports = __webpack_public_path__ + "resources/img/sp_intro.ea90b54d3373a628fb57839691fa3f9c.png";